import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { CommentsList } from '@widgets/shared/Comments/CommentsList/index.tsx';
import { useUser } from '@shared/hooks/index.ts';
import { useRecommendedArticleQuery } from '@src/api/api-hooks/articles/useRecommendedArticleQuery.ts';
import { Loader } from '@src/library/components/common/index.ts';

type PT = {};
export const RecommendedArticleComments = ({}: PT) => {
  const { hash } = useParams();

  const { data: recommendedData } = useRecommendedArticleQuery({ hash });

  const { user } = useUser();
  const isContentAuthor = useMemo(
    () => user?.id === recommendedData?.invite.article.author.id,
    [recommendedData, user]
  );

  return recommendedData ? (
    <CommentsList
      isPaid={recommendedData?.status === 'auth'}
      isContentAuthor={isContentAuthor}
      comments={recommendedData.invite.article.comments}
      article={recommendedData.invite.article.id}
    />
  ) : (
    <Loader />
  );
};
